import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TrustMarquee } from "@/components/site/TrustMarquee";
import { About } from "@/components/site/About";
import { AreasOfCare } from "@/components/site/AreasOfCare";
import { PatientJourney } from "@/components/site/PatientJourney";
import { ValueTrust } from "@/components/site/ValueTrust";
import { HealthEducation } from "@/components/site/HealthEducation";
import { Location } from "@/components/site/Location";
import { Faq } from "@/components/site/Faq";
import { Appointment } from "@/components/site/Appointment";
import { ContactCTA } from "@/components/site/ContactCTA";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="bg-[#FFFFFF]">
      <Navbar />
      <main>
        <Hero />
        <TrustMarquee />
        <About />
        <AreasOfCare />
        <PatientJourney />
        <ValueTrust />
        <HealthEducation />
        <Location />
        <Faq />
        <Appointment />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}
